import { useCallback, useState } from "react";

export function useTheme() {
  const [theme, setThemeState] = useState(() => document.documentElement.dataset.theme || "dark");

  const setTheme = useCallback((nextTheme) => {
    document.documentElement.dataset.theme = nextTheme;
    document.documentElement.style.colorScheme = nextTheme;
    window.localStorage.setItem("theofast-theme", nextTheme);
    setThemeState(nextTheme);
  }, []);

  const toggleTheme = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [setTheme, theme]);
  return { theme, toggleTheme };
}
